// extracted by css-extract-rspack-plugin
export default {"Item":"survey-response-form_Item__JM33o","Wrapper":"survey-response-form_Wrapper__Mo1i1"};